import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Typography,
    FormControl,
    InputLabel,
    Divider,
    Button,
} from '@material-ui/core'
import Select from 'react-select';
import useStyles from './styles'
import axios from 'axios'

// components
import TitlesSelector from './TitlesSelector'


export default function JobTitleSelectionStep1(props) {

    const classes = useStyles()

    const [selectedCompKitTitle, setSelectedCompKitTitle] = useState(null)

    const [jobSubFunctions, setJobSubFunctions] = useState([])

    const [selectedFunction, setSelectedFunction] = useState('')
    const [selectedSubFunction, setSelectedSubFunction] = useState('')
    const [selectedResponsibility, setSelectedResponsibility] = useState('')

    const masterData = props.masterData
    const jobClassifications = [
        {value: 'E', label: 'Executive' },
        {value: 'M', label: 'People Mgmt' },
        {value: 'P', label: 'Professional' },
        {value: 'S', label: 'Support' },
    ]

    const handleQuestionsFilling = () => {
        props.onQuestionsFilling({
            job_function:selectedFunction.value,
            job_subfunction: selectedSubFunction.value,
            job_category: selectedResponsibility.value,
        })
    }

    const handleFunctionSelection = (selectedOption) => {
        setSelectedFunction(selectedOption)
        const payload = {
            job_function: selectedOption.value
        }
        axios.post('/api/find_subfunc_emptype', payload).then(res => {
            if(res.data.status === true) {
                const subFunctions = res.data.data.jobSubFuncs.map(subFunction => subFunction.job_subfunction )
                setJobSubFunctions(subFunctions)
            }
        })
    }

    return (
        <>
            <div className={classes.form}>
                <Typography gutterBottom>Choose Job Title from CompKit List</Typography>
                <Box m={1} display="flex" justifyContent="center">
                    <FormControl className={classes.formControl}>
                        {/* <InputLabel htmlFor="max-width">Job List</InputLabel> */}
                        <TitlesSelector
                            onSelection={(title) => setSelectedCompKitTitle(title)}
                        />
                    </FormControl>
                </Box>
                <Box m={1} display="flex" justifyContent="center">
                    <Button
                        variant='contained'
                        color='primary'
                        onClick={
                                () => props.onCompKitTitleSelection(selectedCompKitTitle)
                        }
                    >
                        Next
                    </Button>
                </Box>
            </div>
            <Divider />
            <div className={classes.form} noValidate>
                <Box m={1} display="flex" justifyContent="center">
                    <Typography variant='h6'>Or Answer Following Questions</Typography>
                </Box>

                <Typography gutterBottom>
                    Q: What Classification is this position part of?
                </Typography>
                <FormControl className={classes.formControl}>
                    <InputLabel htmlFor="sel_func">Classification</InputLabel>
                    <Select
                        value={selectedResponsibility}
                        onChange={(selectedOption) => setSelectedResponsibility(selectedOption)}
                        options={jobClassifications}
                    />
                </FormControl>

                <Typography gutterBottom>
                    Q: What Function is this position part of?
                </Typography>
                <FormControl className={classes.formControl}>
                    <InputLabel htmlFor="sel_func">Functions</InputLabel>
                    <Select
                        value={selectedFunction}
                        onChange={handleFunctionSelection}
                        options={
                            masterData.jobFunctions.map(jobFunction => {
                                return { value: jobFunction, label: jobFunction}
                            })
                        }
                    />

                </FormControl>

                <Typography gutterBottom>
                    Q: What Sub-Function is this position part of?
                </Typography>
                <FormControl className={classes.formControl}>
                    <InputLabel htmlFor="sel_func">Sub Functions</InputLabel>
                    <Select
                        value={selectedSubFunction}
                        onChange={(selectedOption) => setSelectedSubFunction(selectedOption) }
                        options={
                            jobSubFunctions.map(jobSubFunction => {
                                return { value: jobSubFunction, label: jobSubFunction}
                            })
                        }
                    />
                </FormControl>
                <FormControl className={classes.formControl}>
                    <Button
                        variant='contained'
                        color='primary'
                        onClick={handleQuestionsFilling}
                    >
                        Next
                    </Button>
                </FormControl>
            </div>
        </>
    )
}

JobTitleSelectionStep1.propTypes = {
    onCompKitTitleSelection: PropTypes.func.isRequired,
    onQuestionsFilling: PropTypes.func.isRequired,
    masterData: PropTypes.object.isRequired,
}
